import {
    all,
    fork,
    take,
    cancelled,
    takeLatest,
    race,
    put,
    call,
    select
} from 'redux-saga/effects';

import * as selectors from './Selectors';

import {
    GET_USER_ORG,
    LOGOUT_USER,
    GET_ORGS_COLLECTION,
    SET_ACTIVE_USER_ORG,
    GET_ACTIVE_ORG_COLLECTION,
    VALIDATE_SHORT_CODE,
    WATCH_SELECTED_ORG,
    FETCH_ORG_EXPORT_DATA,
    FETCH_UNASSIGNED_DEVICES
} from '../actions/types';

import { eventChannel } from 'redux-saga';

import {
    storeOrgData,
    getOrgCollectionSuccess,
    getOrgCollectionFailure,
    // settingActiveOrgSuccess,
    settingActiveOrgFailure,
    setShortCodeValidationResult
} from '../actions/Org';

import { openSnackbar } from 'store/actions/Snackbar';

import { orgPropertiesCollectionWatch } from './Properties';

import { db } from 'config/firebase';

import { otcCollectionWatch } from './Otc';

// Loggers
import { log } from '../../utils/Loggers';
import {
    collection,
    doc,
    getDoc,
    getDocs,
    onSnapshot,
    query,
    updateDoc,
    where
} from 'firebase/firestore';
import {
    getAssociateMembersSuccess,
    getCommunityMembersSuccess,
    getInvitedMembersSuccess,
    getOrgGuestsSuccess,
    getOrgInvitesV2Success,
    storeUnassignedDevices
} from 'store/actions/Managers';
import { intercomCollectionWatch } from './Intercom';
import { callsCollectionWatch } from './Calls';
import { userRoles } from 'utils/constants';
import UnassignedDevicesService from 'services/unassigned-devices.service';

const orgsCollectionRef = collection(db, 'orgs');

//////////////// Get User Organization ////////////////

const watchAll = user => {
    if (user.type === 'super_admin' || user.external) return true;
    return false;
};

export function* orgCollectionWatch(user) {
    let unsubscribeUserOrgData;

    const orgCollectionChannel = eventChannel(emit => {
        unsubscribeUserOrgData = watchAll(user)
            ? onSnapshot(orgsCollectionRef, querySnapshot => {
                  var org = [];
                  querySnapshot.forEach(doc => {
                      var contactName;
                      if (user.type === userRoles.SUPER_ADMIN) {
                          if (doc.data().users.length) {
                              const primary = doc
                                  .data()
                                  .users.filter(manager => manager.primary === true);
                              contactName = primary.length
                                  ? `${primary[0].first_name} ${primary[0].last_name}`
                                  : null;
                          }
                          org.push({ ...doc.data(), contact_name: contactName });
                      } else if (user.external) {
                          if (
                              user?.overwatch ||
                              doc.data().modules.includes('ramco_virtual_guard')
                          ) {
                              if (doc.data().users.length) {
                                  const primary = doc
                                      .data()
                                      .users.filter(manager => manager.primary === true);
                                  contactName = primary.length
                                      ? `${primary[0].first_name} ${primary[0].last_name}`
                                      : null;
                              }
                              org.push({ ...doc.data(), contact_name: contactName });
                          }
                      }
                  });
                  emit(org);
              })
            : onSnapshot(
                  query(orgsCollectionRef, where('org_id', 'in', user.org_ids)),
                  querySnapshot => {
                      var org = [];
                      querySnapshot.forEach(doc => {
                          var contactName;
                          if (doc.data().users.length) {
                              const primary = doc
                                  .data()
                                  .users.filter(manager => manager.primary === true);
                              contactName = primary.length
                                  ? `${primary[0].first_name} ${primary[0].last_name}`
                                  : null;
                          }
                          org.push({ ...doc.data(), contact_name: contactName });
                      });
                      emit(org);
                  }
              );
        return unsubscribeUserOrgData;
    });

    try {
        while (true) {
            const { userSignOut, userOrgData } = yield race({
                userSignOut: take(LOGOUT_USER),
                userOrgData: take(orgCollectionChannel)
            });

            if (userSignOut) {
                orgCollectionChannel.close();
            } else {
                yield put(storeOrgData({ orgs: userOrgData, orgId: user.active_org_id }));
                const activeOrg = yield select(selectors._activeOrg);
                const orgProperties = yield select(selectors._orgProperties);
                const otcCodes = yield select(selectors._otcCodes);
                const calls = yield select(selectors._activeCalls);
                const coms = yield select(selectors._activeComs);
                const communityMembers = yield select(selectors._communityMembers);
                const orgInvitesV2 = yield select(selectors._orgInvitesV2);
                console.log('Data in Org(s) from Watch List updating');
                console.log(``);
                if (user.role === userRoles.OPERATOR && !calls && !coms) {
                    // console.log(
                    //     '[INITIAL] - Starting Calls/Intercom Collection Listeners'
                    // );
                    yield fork(callsCollectionWatch, {
                        payload: { user, orgs: userOrgData }
                    });
                    yield fork(intercomCollectionWatch, user);
                }
                if (activeOrg) {
                    if (!orgProperties) {
                        // console.log(
                        //     '[INITIAL] - Starting orgProperties Collection Listener'
                        // );
                        yield fork(orgPropertiesCollectionWatch, {
                            payload: { ...activeOrg }
                        });
                    }
                    if (!orgInvitesV2) {
                        yield fork(orgInvitesV2CollectionWatch, {
                            payload: { ...activeOrg }
                        });
                    }
                    if (!otcCodes) {
                        // console.log('[INITIAL] - Starting OTC Collection Listener');
                        yield fork(
                            otcCollectionWatch,
                            activeOrg.org_id,
                            activeOrg.property_id
                        );
                    }
                    if (communityMembers === null) {
                        yield fork(activeOrgCollectionWatch, {
                            payload: { id: activeOrg.org_id, userType: user.type }
                        });
                    }
                }
            }
        }
    } catch (error) {
        log('Org Error: getting user org collection data (FS)', {
            error,
            user
        });
    } finally {
        unsubscribeUserOrgData();
        if (yield cancelled()) {
            orgCollectionChannel.close();
            unsubscribeUserOrgData();
        }
    }
}

export function* fetchUnassignedDevicesSaga({ payload: orgId }) {
    if (!orgId) return;
    try {
        const devices = yield call(
            [UnassignedDevicesService, UnassignedDevicesService.getUnassignedDevices],
            orgId
        );
        yield put(storeUnassignedDevices(Array.isArray(devices) ? devices : []));
    } catch (error) {
        log('Orgs Error: getting unassigned devices', { error });
    }
}

export function* activeOrgCollectionWatch({ payload }) {
    // console.log('[INITIAL/RESET ORG] - Getting Active Org RTDB Data');
    const { id } = payload;
    const orgMembersCollectionRef = collection(db, 'orgs', id, 'members');
    const orgGuestsCollectionRef = collection(db, 'orgs', id, 'guests');

    const normalizeParticipant = raw => ({
        ...raw,
        first_name: raw.first_name ? raw.first_name.toLowerCase() : '',
        last_name: raw.last_name ? raw.last_name.toLowerCase() : '',
        email: raw.email ? raw.email.toLowerCase() : false
    });

    const OrgMembersChannel = eventChannel(emit => {
        const unsubscribeOrgMembersData = onSnapshot(
            orgMembersCollectionRef,
            querySnapshot => {
                const members = [];
                const membersByProperty = [];
                const associateMembers = [];
                querySnapshot.forEach(docSnap => {
                    const data = normalizeParticipant(docSnap.data());
                    members.push(data);
                    Object.keys(data.properties || {}).forEach(propId => {
                        const prop = data.properties[propId];
                        if (
                            prop.role === userRoles.RESIDENT ||
                            prop.role === userRoles.TENANT
                        ) {
                            membersByProperty.push({
                                ...data,
                                key: `${data.uid}${propId}`,
                                address: prop.address,
                                property_id: propId
                            });
                        } else if (prop.role === 'non-member') {
                            associateMembers.push({
                                ...data,
                                id: data.uid,
                                // The org-participant doc has no top-level `role` (role is nested per
                                // property, since one person can hold a different role on each unit) —
                                // but normalizeOwners()/CreateUpdateDeviceModal read a flat `role` to
                                // build a device's access_type. Without this, an associate member's
                                // devices were created with access_type: '' instead of 'non-member'.
                                role: prop.role,
                                key: `${data.uid}${propId}`,
                                address: prop.address,
                                property_id: propId
                            });
                        }
                    });
                });
                const membersCount = (() => {
                    const s = new Set();
                    for (const m of members) {
                        const hasResidentOrTenant = Object.values(
                            m.properties || {}
                        ).some(
                            prop =>
                                prop.role === userRoles.RESIDENT ||
                                prop.role === userRoles.TENANT
                        );
                        if (hasResidentOrTenant && m.uid) {
                            s.add(m.uid);
                        }
                    }
                    return s.size;
                })();
                emit({ members, membersByProperty, membersCount, associateMembers });
            }
        );
        return () => {
            unsubscribeOrgMembersData();
        };
    });

    const OrgGuestsChannel = eventChannel(emit => {
        const unsubscribeOrgGuestsData = onSnapshot(
            orgGuestsCollectionRef,
            querySnapshot => {
                const guests = [];
                const guestsByProperty = [];
                querySnapshot.forEach(docSnap => {
                    const data = normalizeParticipant(docSnap.data());
                    guests.push(data);
                    Object.keys(data.properties || {}).forEach(propId => {
                        const prop = data.properties[propId];
                        if (prop.role === userRoles.GUEST) {
                            guestsByProperty.push({
                                ...data,
                                key: `${data.uid}${propId}`,
                                address: prop.address,
                                property_id: propId
                            });
                        }
                    });
                });
                const guestsCount = (() => {
                    const s = new Set();
                    for (const g of guests) {
                        const hasGuest = Object.values(g.properties || {}).some(
                            prop => prop.role === userRoles.GUEST
                        );
                        if (hasGuest && g.uid) {
                            s.add(g.uid);
                        }
                    }
                    return s.size;
                })();
                emit({ guests: guestsByProperty, guestsCount });
            }
        );
        return () => {
            unsubscribeOrgGuestsData();
        };
    });

    // const OrgAccessLogChannel = eventChannel(emit => {
    //     const query = rtdbQuery(activeOrgAccessLog, orderByChild('access_time'));

    //     const unsubscribeOrgAccessLogData = onValue(query, snapshot => {
    //         if (snapshot && snapshot.exists()) {
    //             const log = snapshot.val();
    //             const accessLogList = Object.entries(log).map(([logItemId, record]) => ({
    //                 logItemId,
    //                 ...record
    //             }));

    //             accessLogList.sort((a, b) => b.access_time.localeCompare(a.access_time));
    //             emit(accessLogList);
    //         } else {
    //             emit([]);
    //         }
    //     });
    //     return () => {
    //         unsubscribeOrgAccessLogData();
    //     };
    // });

    yield fork(fetchUnassignedDevicesSaga, { payload: id });

    const detachSagaEmitters = () => {
        OrgMembersChannel.close();
        OrgGuestsChannel.close();
        // OrgPanelsChannel.close();
        // OrgAccessLogChannel.close();
    };

    try {
        while (true) {
            const {
                userSignOut,
                resettingOrg,
                orgMembersData,
                orgGuestsData
                // orgPanelsData,
                // orgAccessLogData,
            } = yield race({
                userSignOut: take(LOGOUT_USER),
                resettingOrg: take(SET_ACTIVE_USER_ORG),
                orgMembersData: take(OrgMembersChannel),
                orgGuestsData: take(OrgGuestsChannel)
                // orgPanelsData: take(OrgPanelsChannel),
                //orgAccessLogData: take(OrgAccessLogChannel)
            });

            const currentMembers = yield select(selectors._communityMembers);
            const currentAccessLog = yield select(selectors._accessLog);
            const initialized = yield select(selectors._appInitialized);

            if (userSignOut) {
                detachSagaEmitters();
            } else if (resettingOrg) {
                if (initialized) {
                    if (
                        (currentMembers && currentMembers?.length) ||
                        (currentAccessLog && currentAccessLog?.length)
                    ) {
                        detachSagaEmitters();
                    }
                }
            } else if (orgMembersData) {
                yield put(getCommunityMembersSuccess(orgMembersData));
                yield put(getAssociateMembersSuccess(orgMembersData.associateMembers));
                // } else if (orgAccessLogData) {
                //     yield put(updateAccessLog(orgAccessLogData));
            } else if (orgGuestsData) {
                yield put(getOrgGuestsSuccess(orgGuestsData));
            }
            // else if (orgAccessLogData) {
            //     yield put(updateAccessLog(orgAccessLogData));
            // }
        }
    } catch (error) {
        //TODO: Error Handling
        log('Orgs Error: getting imports/members/access_log data (RTDB)', {
            error
        });
    } finally {
        // detachFBListeners(); // Detaching firebase listeners
        if (yield cancelled()) {
            detachSagaEmitters(); // Detaching saga event emitter
            // detachFBListeners(); // Detaching firebase listeners
        }
    }
}

export function* getOrgsCollection() {
    try {
        const snapshot = yield call(getDocs, orgsCollectionRef);
        const allOrgs = snapshot.docs.map(doc => doc.data());
        yield put(getOrgCollectionSuccess(allOrgs));
    } catch (error) {
        log('Org Error: getting all orgs data (FS)', {
            error
        });
        yield put(getOrgCollectionFailure(error));
    }
}

// export function* getOrgByShortCode(shortCode) {
//     try {
//         const orgsCollectionRef = collection(db, 'orgs');
//         const q = query(orgsCollectionRef, where('short_code', '==', shortCode));
//         const querySnapshot = yield call(getDocs, q);

//         if (!querySnapshot.empty) {
//             const doc = querySnapshot.docs[0];
//             return doc.data();
//         } else {
//             return null;
//         }
//     } catch (err) {
//         log('Org Error: getting org by short code (FS)', {
//             error: err,
//             shortCode
//         });
//         return null;
//     }
// }

export function* getOrgById(orgId) {
    try {
        const orgDocRef = doc(db, 'orgs', orgId);
        const orgDoc = yield call(getDoc, orgDocRef);

        if (orgDoc.exists()) {
            return orgDoc.data();
        }
    } catch (err) {
        log('Org Error: getting org by id (FS)', {
            error: err,
            orgId
        });
    }
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////// Setting Active Org /////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const settingActiveOrgRequest = ({ active_org_id, active_station_id, userId }) => {
    const userDocRef = doc(db, 'users', userId);

    return new Promise((resolve, reject) => {
        updateDoc(userDocRef, {
            active_org_id,
            active_station_id: active_station_id || null
        })
            .then(() => resolve({ res: true }))
            .catch(error => reject({ error }));
    });
};

export function* settingActiveOrg({ payload }) {
    const { org_id } = payload;
    const userData = yield select(selectors._userData);
    const active_org_id = org_id;
    const active_station_id = userData.active_station_id;
    const userId = userData.uid;

    const { res, error } = yield call(() =>
        settingActiveOrgRequest({ active_org_id, active_station_id, userId })
    );

    if (res) {
        /****************/
        /** DO NOTHING **/
        /****************/
        // console.log('org switched!!');
        return;

        // yield put(
        //     settingActiveOrgSuccess({
        //         activeOrg: payload
        //     })
        // );
        // yield put(
        //     settingActivePermissions({
        //         activePermissions: activePermissions
        //     })
        // );
        // yield fork(
        //                         otcCollectionWatch,
        //                         latestActiveOrg.org_id,
        //                         latestActiveOrg.property_id
        //                     );
        // yield fork(otcCollectionWatch, payload.org_id, payload.property_id); // org otc data
    } else {
        yield put(
            openSnackbar({
                open: true,
                message: `Failed: Org was not focused successfully.`,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                autoHideDuration: 3000
            })
        );
        log('Org Error: setting active user org ID (FS)', {
            error,
            org_id
        });
        yield put(settingActiveOrgFailure(error));
    }
}

// export function* settingActiveOrg({ payload }) {
//     const { org_id } = payload;
//     const userData = yield select(selectors._userData);
//     const active_org_id = org_id;
//     const active_station_id = userData.active_station_id;
//     const userId = userData.uid;
//     const previousActiveOrg = userData.active_org_id;

//     const activePermissions = userData?.orgs[active_org_id]?.permissions || [];

//     const intercomQuery = yield call(() =>
//         getDocs(
//             query(
//                 intercomCollectionRef,
//                 where('connected_by', '==', userId),
//                 where('status', 'in', ['pending', 'active'])
//             )
//         )
//     );

//     const callsQuery = yield call(() =>
//         getDocs(
//             query(
//                 callsCollectionRef,
//                 where('fielded_by', '==', userId),
//                 where('status', 'in', ['pending', 'active'])
//             )
//         )
//     );

//     if (!intercomQuery.empty || !callsQuery.empty) {
//         console.log(
//             'Hiiiiiiii im trying to set active org but im preventing it causeof active call, intercom!!!!!!!!'
//         );
//         yield put(
//             openSnackbar({
//                 open: true,
//                 message: `Failed: Org was not focused due to active intercom or call.`,
//                 variant: 'alert',
//                 alert: {
//                     color: 'error'
//                 },
//                 autoHideDuration: 3000
//             })
//         );
//     } else if (active_org_id === previousActiveOrg) {
//         console.log(
//             'Hooolllaaaaaa im just passing active org along cause its already same as previous!!!!!!!!'
//         );
//         yield put(
//             settingActiveOrgSuccess({
//                 activeOrg: payload
//             })
//         );
//         yield put(
//             settingActivePermissions({
//                 activePermissions: activePermissions
//             })
//         );
//     } else {
//         const { res, error } = yield call(() =>
//             settingActiveOrgRequest({ active_org_id, active_station_id, userId })
//         );

//         if (res) {
//             yield put(
//                 settingActiveOrgSuccess({
//                     activeOrg: payload
//                 })
//             );
//             yield put(
//                 settingActivePermissions({
//                     activePermissions: activePermissions
//                 })
//             );
//             yield fork(otcCollectionWatch, payload.org_id, payload.property_id); // org otc data
//             console.log(
//                 'Yoooooooo im setting active org successfully cause it needed to change',
//                 org_id
//             );
//         } else {
//             yield put(
//                 openSnackbar({
//                     open: true,
//                     message: `Failed: Org was not focused successfully.`,
//                     variant: 'alert',
//                     alert: {
//                         color: 'error'
//                     },
//                     autoHideDuration: 3000
//                 })
//             );
//             log('Org Error: setting active user org ID (FS)', {
//                 error,
//                 org_id
//             });
//             yield put(settingActiveOrgFailure(error));
//         }
//     }
// }

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////// Org Invites Collection ///////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export function* orgInvitesV2CollectionWatch({ payload }) {
    const org = payload;
    let unsubscribeOrgInvitesV2Data;

    // Mirror the backend's live-read contract (`notDeleted()` =
    // `deleted_at == null`): archived invites (accepted/declined/deleted all
    // stamp `deleted_at`) drop out of the stream at the source, so every
    // derived slice below — including the `invitedMembers` backfill — stays
    // clean. Two equality filters need no composite index.
    const orgInvitesV2Query = query(
        collection(db, 'invites'),
        where('org_id', '==', org.org_id),
        where('deleted_at', '==', null)
    );

    const orgInvitesV2Channel = eventChannel(emit => {
        unsubscribeOrgInvitesV2Data = onSnapshot(orgInvitesV2Query, querySnapshot => {
            const invites = querySnapshot.docs.map(doc => ({
                ...doc.data(),
                id: doc.id
            }));
            emit(invites);
        });

        return () => unsubscribeOrgInvitesV2Data();
    });

    try {
        while (true) {
            const { userSignOut, resettingOrg, orgInvitesV2Data } = yield race({
                userSignOut: take(LOGOUT_USER),
                resettingOrg: take(SET_ACTIVE_USER_ORG),
                orgInvitesV2Data: take(orgInvitesV2Channel)
            });

            if (userSignOut || resettingOrg) {
                orgInvitesV2Channel.close();
            } else {
                yield put(
                    getOrgInvitesV2Success({
                        all: orgInvitesV2Data,
                        members: orgInvitesV2Data.filter(i => i.type === 'member'),
                        operators: orgInvitesV2Data.filter(
                            i => i.role === userRoles.OPERATOR
                        ),
                        guests: orgInvitesV2Data.filter(i => i.role === 'guest')
                    })
                );

                // Backfill legacy `state.manager.invitedMembers` consumers
                // (AccessControl `RequestsTable`, VirtualGuard pending list)
                // off the unified `invites` collection. The legacy
                // `orgInvitesCollectionWatch` saga used to populate this slot
                // from the now-empty `guest_invites` collection; consumers
                // expect the same `[tenant, resi]` filter shape as the legacy
                // payload, so apply it here before dispatching.
                yield put(
                    getInvitedMembersSuccess(
                        orgInvitesV2Data.filter(
                            i =>
                                i.role === userRoles.TENANT ||
                                i.role === userRoles.RESIDENT
                        )
                    )
                );
            }
        }
    } catch (error) {
        log('Org Error: getting org invites v2 collection data (FS)', { error, org });
    } finally {
        if (yield cancelled()) {
            orgInvitesV2Channel.close();
        }
    }
}

function* validateShortCodeSaga(action) {
    const shortCode = action.payload;

    try {
        const shortCodeQuery = query(
            collection(db, 'orgs'),
            where('short_code', '==', shortCode)
        );
        const snapshot = yield call(getDocs, shortCodeQuery);

        if (snapshot.empty) {
            yield put(setShortCodeValidationResult(true, null));
        } else {
            yield put(setShortCodeValidationResult(false, 'Short code already in use.'));
        }
    } catch (error) {
        yield put(setShortCodeValidationResult(false, 'Validation failed.'));
    }
}

//TODO: move this to api
function* fetchOrgCsvExportData({ payload }) {
    try {
        const { uids, fetchDevices, resolve, orgId } = payload;

        let users = [];
        const chunkSize = 30;
        for (let i = 0; i < uids.length; i += chunkSize) {
            const chunk = uids.slice(i, i + chunkSize);
            const q = query(collection(db, 'users'), where('uid', 'in', chunk));
            const snap = yield call(getDocs, q);
            users.push(...snap.docs.map(doc => ({ uid: doc.id, ...doc.data() })));
        }

        let orgDevices = [];
        if (fetchDevices) {
            const q = query(collection(db, 'devices'), where('org_id', '==', orgId));
            const snap = yield call(getDocs, q);
            orgDevices = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

            const devicesByUid = {};
            for (const device of orgDevices) {
                const uid = device?.owner?.uid;
                if (uid && uids.includes(uid)) {
                    if (!devicesByUid[uid]) devicesByUid[uid] = [];
                    devicesByUid[uid].push(device);
                }
            }

            users = users.map(user => ({
                ...user,
                devices: devicesByUid[user.uid] || []
            }));
        }

        resolve({ users });
    } catch (error) {
        console.error('Error fetching export data:', error);
        payload.resolve({ users: [], error });
    }
}

///////////// Action Creators For Root Saga //////////////////

export function* getOrgExportData() {
    yield takeLatest(FETCH_ORG_EXPORT_DATA, fetchOrgCsvExportData);
}

export function* getAllOrgs() {
    yield takeLatest(GET_ORGS_COLLECTION, getOrgsCollection);
}

export function* watchSelectedOrgCollection() {
    yield takeLatest(WATCH_SELECTED_ORG, activeOrgCollectionWatch);
}

export function* getOrgCollection() {
    yield takeLatest(GET_USER_ORG, orgCollectionWatch);
}

export function* getActiveOrgCollection() {
    yield takeLatest(GET_ACTIVE_ORG_COLLECTION, activeOrgCollectionWatch);
}

export function* setActiveOrg() {
    yield takeLatest(SET_ACTIVE_USER_ORG, settingActiveOrg);
}

export function* watchFetchUnassignedDevices() {
    yield takeLatest(FETCH_UNASSIGNED_DEVICES, fetchUnassignedDevicesSaga);
}

export function* watchValidateShortCode() {
    yield takeLatest(VALIDATE_SHORT_CODE, validateShortCodeSaga);
}

export default function* rootSaga() {
    yield all([
        fork(getOrgCollection),
        fork(getAllOrgs),
        fork(setActiveOrg),
        fork(getActiveOrgCollection),
        fork(watchValidateShortCode),
        fork(watchSelectedOrgCollection),
        fork(getOrgExportData),
        fork(watchFetchUnassignedDevices)
    ]);
}
